import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ICommunityEngagementActions, IThunkGetExemptionCategories } from '../types';

const onGetExemptionCategories: IThunkGetExemptionCategories = thunk(
  async ({ setExemptionCategories }: Actions<ICommunityEngagementActions>, clinicId) => {
    const categories = await api.communityEngagement
      .getExemptionCategories(clinicId)
      .then(response => response.data);

    setExemptionCategories(categories);
  },
);

export default onGetExemptionCategories;
